<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-select v-model="selectedRegion" size="large" clearable @change="onChangeFilter(true)"
                 placeholder="Viloyat">
        <el-option v-for="region in regions" :value="region.id" :label="region.title" :key="region.id"></el-option>
      </el-select>

      <el-select v-model="selectedDistrict" size="large" clearable @change="onChangeFilter(false)" placeholder="Tuman">
        <el-option v-for="district in districts" :value="district.id" :label="district.title"
                   :key="district.id"></el-option>
      </el-select>
      <el-button size="large" type="primary" @click="$router.push({name: 'ForumAdd'})">Qo'shish</el-button>
    </div>
    <el-table :data="tableData" class="table" border height="calc(100vh - 263px)">
      <el-table-column type="index" label="T/R" width="80" align="center"/>
      <el-table-column prop="districtName" label="Tuman" min-width="220"/>
      <el-table-column prop="nearby" label="Joylashuv" min-width="220"/>
      <el-table-column prop="responsiblePerson" label="Mas'ul shaxs" min-width="220"/>
      <el-table-column prop="date" label="Sanasi" width="150">
        <template #default="scope">
          {{ $moment(scope.row.createdAt).format('DD.MM.YYYY') }}
        </template>
      </el-table-column>
      <el-table-column label="" width="200" align="center">
        <template #default="scope">
          <el-button type="primary" size="small"
                     @click="$router.push({name: 'ForumEdit', params:{id: scope.row.id}})">Tahrirlash
          </el-button>
          <el-button type="danger" size="small"
                     @click="onClickDelete(scope.row.id)">O'chirish
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span v-if="totalElements">Jami: {{ totalElements }}</span>
          <el-pagination
              v-model:current-page="currentPage"
              class="pagination"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="sizes, prev, pager, next"
              :total="totalElements"
              v-model:page-size="size"
              :page-count="totalPages"
              :background="true"
              :page-sizes="[15,20,30,50,100,200, 500, 1000]"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

export default {
  name: "ForumList",
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
  },
  data() {
    return {
      loading: false,
      selectedRegion: null,
      selectedDistrict: null,
      tableData: [],

      regions: [],
      districts: [],

      totalElements: 0,
      totalPages: null,
      size: 20,
      page: 1,

      cancelingReasons: [],

      declineDialog: false,
      acceptDialog: false,
      declineForm: {
        questionId: null,
        context: null,
      },
      acceptForm: {
        questionId: null,
        context: null,
      },

      rules: {
        context: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.page = 1;
      this.$router
          .replace({
            query: {...this.$route.query, size: val},
          }).then(() => {
        this.getForumList();
      }).catch(() => {
      });
    },
    handleCurrentChange(val) {
      this.$router
          .replace({
            query: {...this.$route.query, page: val},
          }).then(() => {
        this.getForumList();
      }).catch(() => {
      });
    },

    onChangeFilter(isRegion = false) {
      this.page = 1;
      if (isRegion) {
        this.districts = []
        this.selectedDistrict = null
        this.getDistricts()
      }
      this.$router.replace({
        query: {
          ...this.$route.query,
          region: this.selectedRegion,
          district: this.selectedDistrict
        }
      })
      this.getForumList()
    },
    getRegions() {
      this.regionsLoading = true
      this.$http.get('/api/v1/regions').then(({data}) => {
        this.regions = data.regions
      }).catch(() => {

      }).finally(() => {
        this.regionsLoading = false
      })
    },
    getDistricts() {
      this.districtsLoading = true
      this.$http.get('/api/v1/districts', {
        params: {
          region_id: this.selectedRegion
        }
      }).then(({data}) => {
        this.districts = data.districts
      }).catch(() => {

      }).finally(() => {
        this.districtsLoading = false
      })
    },
    onClickDelete(id) {
      ElMessageBox.confirm(
          'Ma\'lumoitni o\'chirasizmi?',
          'Diqqat!',
          {
            confirmButtonText: 'Ha',
            cancelButtonText: 'Bekor qilish',
            type: 'warning',
          }
      )
          .then(() => {
            this.loading = true
            this.$http.delete(`/api/v2/info/forum/${id}`).then(() => {
              ElMessage({
                type: 'success',
                message: 'Muvaffaqqiyatli o\'chirildi',
              })
              this.getForumList();
            }).catch(() => {
              ElNotification({
                type: 'error',
                title: 'Xatolik',
                message: 'Iltimos, qayta urinib ko\'ring',
              })
            }).finally(() => {
              this.loading = false
            })

          })
          .catch(() => {
            ElMessage({
              type: 'info',
              message: 'O\'chirish bekor qilindi',
            })
          })
    },
    getForumList() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size ? parseInt(this.$route.query.size || "") : 20;
      this.$http.get(`api/v2/info/forum/filter`, {
        params: {
          regionId: this.selectedRegion,
          districtId: this.selectedDistrict,
          page: this.page - 1,
          size: this.size
        }
      }).then(({data}) => {
        this.tableData = data.content
        this.totalElements = data.totalElements;
        this.totalPages = data.totalPages;
        this.size = data.size;
      }).catch(({response}) => {
        ElNotification.error({message: response.data.message || "Ma'lumot yuklashda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring."})
      }).finally(() => {
        this.loading = false
      })
    },
  },

  mounted() {
    if (this.$route.query.region) {
      this.selectedRegion = parseInt(this.$route.query.region)
      this.getDistricts()
    }
    if (this.$route.query.district) {
      this.selectedDistrict = parseInt(this.$route.query.district)
    }
    this.getRegions()
    this.$nextTick(() => {
      this.getForumList();
    })
  }

}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
  align-items: center;
}

:deep(.el-table .el-table__cell) {
  z-index: unset !important;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 3px;
  height: 40px;
}

.pagination-wrapper > span {
  color: #0A194E;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>